// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drp-container {
  font-family: "Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #14285a;
  -webkit-user-select: none;
          user-select: none;
}

.drp-header-title {
  font-size: 14px;
  font-weight: 600;
  color: #14285a;
  margin-bottom: 12px;
}

/* Presets bar */
.drp-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.drp-preset-chip {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 14px;
  border: 1px solid #d7e8ec;
  background-color: #f0f7f8;
  color: #007c92;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.drp-preset-chip:hover {
  background-color: #e0eff2;
  border-color: #007c92;
}

.drp-preset-chip.active {
  background-color: #007c92;
  color: #ffffff;
  border-color: #007c92;
}

/* Single unified input display */
.drp-single-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1.5px solid #d7e8ec;
  border-radius: 10px;
  background-color: #ffffff;
  margin-bottom: 14px;
  transition: border-color 0.2s ease;
}

.drp-single-input:focus-within {
  border-color: #007c92;
  box-shadow: 0 0 0 3px rgba(0, 124, 146, 0.1);
}

.drp-input-text-container {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
}

.drp-input-icon {
  color: #007c92;
  font-size: 18px !important;
}

.drp-date-arrow {
  color: #9aa7b2;
  font-size: 14px;
}

.drp-date-placeholder {
  color: #9aa7b2;
  font-weight: 400;
}

.drp-clear-icon {
  color: #9aa7b2;
  font-size: 16px !important;
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;
  transition: color 0.15s ease;
}

.drp-clear-icon:hover {
  color: #e53935;
  background-color: #feebe8;
}

/* Inline Calendar */
.drp-calendar {
  background: #ffffff;
  border: 1px solid #eef2f5;
  border-radius: 12px;
  padding: 10px 8px;
  margin-bottom: 14px;
}

.drp-calendar-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 4px;
}

.drp-month-label {
  font-size: 14px;
  font-weight: 600;
  color: #14285a;
}

.drp-nav-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #556987;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
}

.drp-nav-btn:hover {
  background-color: #f0f7f8;
  color: #007c92;
}

/* Weekday header row */
.drp-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 4px;
}

.drp-weekday {
  font-size: 11px;
  font-weight: 600;
  color: #9aa7b2;
  padding: 4px 0;
  text-transform: uppercase;
}

/* Days grid */
.drp-days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 2px;
}

.drp-day-cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #2c3e50;
  transition: background-color 0.12s ease;
}

.drp-day-cell.empty {
  cursor: default;
}

.drp-day-cell.other-month {
  color: #c5d0d8;
}

.drp-day-number {
  position: relative;
  z-index: 2;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.drp-day-cell:not(.disabled):not(.in-range):not(.range-start):not(.range-end):hover .drp-day-number {
  background-color: #f0f7f8;
  color: #007c92;
}

/* Range Start */
.drp-day-cell.range-start {
  background: linear-gradient(to right, transparent 50%, #e0eff2 50%);
}

.drp-day-cell.range-start.range-end,
.drp-day-cell.range-start:last-child {
  background: transparent;
}

.drp-day-cell.range-start .drp-day-number {
  background-color: #007c92;
  color: #ffffff;
  font-weight: 600;
}

/* Range End */
.drp-day-cell.range-end {
  background: linear-gradient(to left, transparent 50%, #e0eff2 50%);
}

.drp-day-cell.range-end.range-start,
.drp-day-cell.range-end:first-child {
  background: transparent;
}

.drp-day-cell.range-end .drp-day-number {
  background-color: #007c92;
  color: #ffffff;
  font-weight: 600;
}

/* In Range (selected) */
.drp-day-cell.in-range {
  background-color: #e0eff2;
}

.drp-day-cell.in-range .drp-day-number {
  color: #005f70;
  font-weight: 500;
}

/* Hover preview range */
.drp-day-cell.hover-range {
  background-color: #edf7f9;
}

.drp-day-cell.hover-range .drp-day-number {
  color: #007c92;
}

/* Today indicator */
.drp-day-cell.today:not(.range-start):not(.range-end) .drp-day-number {
  border: 1px solid #007c92;
  font-weight: 600;
  color: #007c92;
}

/* Footer buttons */
.drp-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 4px;
}

.drp-reset-btn {
  background: transparent;
  border: none;
  font-size: 13px;
  color: #666666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  font-family: inherit;
  transition: color 0.15s ease;
}

.drp-reset-btn:hover {
  color: #14285a;
  text-decoration: underline;
}

.drp-action-group {
  display: flex;
  gap: 8px;
}

.drp-cancel-btn {
  background: #ffffff;
  border: 1px solid #d7e8ec;
  color: #4a5568;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s ease;
}

.drp-cancel-btn:hover {
  background-color: #f7fafc;
  border-color: #cbd5e0;
}

.drp-apply-btn {
  background-color: #007c92;
  border: 1px solid #007c92;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s ease;
}

.drp-apply-btn:hover {
  background-color: #005f70;
  border-color: #005f70;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DateRangePicker.css"],"names":[],"mappings":"AAAA;EACE,2FAA2F;EAC3F,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mEAAmE;AACrE;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kEAAkE;AACpE;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".drp-container {\n  font-family: \"Work Sans\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  color: #14285a;\n  user-select: none;\n}\n\n.drp-header-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #14285a;\n  margin-bottom: 12px;\n}\n\n/* Presets bar */\n.drp-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.drp-preset-chip {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 14px;\n  border: 1px solid #d7e8ec;\n  background-color: #f0f7f8;\n  color: #007c92;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n}\n\n.drp-preset-chip:hover {\n  background-color: #e0eff2;\n  border-color: #007c92;\n}\n\n.drp-preset-chip.active {\n  background-color: #007c92;\n  color: #ffffff;\n  border-color: #007c92;\n}\n\n/* Single unified input display */\n.drp-single-input {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border: 1.5px solid #d7e8ec;\n  border-radius: 10px;\n  background-color: #ffffff;\n  margin-bottom: 14px;\n  transition: border-color 0.2s ease;\n}\n\n.drp-single-input:focus-within {\n  border-color: #007c92;\n  box-shadow: 0 0 0 3px rgba(0, 124, 146, 0.1);\n}\n\n.drp-input-text-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #2c3e50;\n  font-weight: 500;\n}\n\n.drp-input-icon {\n  color: #007c92;\n  font-size: 18px !important;\n}\n\n.drp-date-arrow {\n  color: #9aa7b2;\n  font-size: 14px;\n}\n\n.drp-date-placeholder {\n  color: #9aa7b2;\n  font-weight: 400;\n}\n\n.drp-clear-icon {\n  color: #9aa7b2;\n  font-size: 16px !important;\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 2px;\n  transition: color 0.15s ease;\n}\n\n.drp-clear-icon:hover {\n  color: #e53935;\n  background-color: #feebe8;\n}\n\n/* Inline Calendar */\n.drp-calendar {\n  background: #ffffff;\n  border: 1px solid #eef2f5;\n  border-radius: 12px;\n  padding: 10px 8px;\n  margin-bottom: 14px;\n}\n\n.drp-calendar-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  padding: 0 4px;\n}\n\n.drp-month-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #14285a;\n}\n\n.drp-nav-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #556987;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease;\n}\n\n.drp-nav-btn:hover {\n  background-color: #f0f7f8;\n  color: #007c92;\n}\n\n/* Weekday header row */\n.drp-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  margin-bottom: 4px;\n}\n\n.drp-weekday {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9aa7b2;\n  padding: 4px 0;\n  text-transform: uppercase;\n}\n\n/* Days grid */\n.drp-days-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  row-gap: 2px;\n}\n\n.drp-day-cell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 34px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  color: #2c3e50;\n  transition: background-color 0.12s ease;\n}\n\n.drp-day-cell.empty {\n  cursor: default;\n}\n\n.drp-day-cell.other-month {\n  color: #c5d0d8;\n}\n\n.drp-day-number {\n  position: relative;\n  z-index: 2;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.drp-day-cell:not(.disabled):not(.in-range):not(.range-start):not(.range-end):hover .drp-day-number {\n  background-color: #f0f7f8;\n  color: #007c92;\n}\n\n/* Range Start */\n.drp-day-cell.range-start {\n  background: linear-gradient(to right, transparent 50%, #e0eff2 50%);\n}\n\n.drp-day-cell.range-start.range-end,\n.drp-day-cell.range-start:last-child {\n  background: transparent;\n}\n\n.drp-day-cell.range-start .drp-day-number {\n  background-color: #007c92;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n/* Range End */\n.drp-day-cell.range-end {\n  background: linear-gradient(to left, transparent 50%, #e0eff2 50%);\n}\n\n.drp-day-cell.range-end.range-start,\n.drp-day-cell.range-end:first-child {\n  background: transparent;\n}\n\n.drp-day-cell.range-end .drp-day-number {\n  background-color: #007c92;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n/* In Range (selected) */\n.drp-day-cell.in-range {\n  background-color: #e0eff2;\n}\n\n.drp-day-cell.in-range .drp-day-number {\n  color: #005f70;\n  font-weight: 500;\n}\n\n/* Hover preview range */\n.drp-day-cell.hover-range {\n  background-color: #edf7f9;\n}\n\n.drp-day-cell.hover-range .drp-day-number {\n  color: #007c92;\n}\n\n/* Today indicator */\n.drp-day-cell.today:not(.range-start):not(.range-end) .drp-day-number {\n  border: 1px solid #007c92;\n  font-weight: 600;\n  color: #007c92;\n}\n\n/* Footer buttons */\n.drp-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 4px;\n}\n\n.drp-reset-btn {\n  background: transparent;\n  border: none;\n  font-size: 13px;\n  color: #666666;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-family: inherit;\n  transition: color 0.15s ease;\n}\n\n.drp-reset-btn:hover {\n  color: #14285a;\n  text-decoration: underline;\n}\n\n.drp-action-group {\n  display: flex;\n  gap: 8px;\n}\n\n.drp-cancel-btn {\n  background: #ffffff;\n  border: 1px solid #d7e8ec;\n  color: #4a5568;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 6px 14px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: all 0.15s ease;\n}\n\n.drp-cancel-btn:hover {\n  background-color: #f7fafc;\n  border-color: #cbd5e0;\n}\n\n.drp-apply-btn {\n  background-color: #007c92;\n  border: 1px solid #007c92;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 6px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background-color 0.15s ease;\n}\n\n.drp-apply-btn:hover {\n  background-color: #005f70;\n  border-color: #005f70;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
